module.exports = __webpack_public_path__ + "img/skin-bg.611934fa.png";